import React, { useCallback } from 'react';
import classnames from 'classnames';
import AdScheduleView from '@bingads-webui-campaign-legacy/ad-schedule/view/index';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { advancedSettingsSectionStyle, toggleButtonStyle, datePickerStyle } from '@bingads-webui-campaign-react/common-styles';
import {
  creationCommonStyle
} from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useBackboneView } from '../shared';

const getStyles = (__, core) =>
  ({
    '@global': {
      ...datePickerStyle(core),
    },
    adScheduleContainer: {
      '& .advanced-scheduling-grid': {
        width: '918px',
      },
      ...creationCommonStyle(core),
      ...advancedSettingsSectionStyle(core),
      '& .radio-inline': {
        display: 'block',
      },
      '& .adschedule-targets-container': {
        borderTop: 'unset',
        paddingTop: '0px',
      },
      '& .toggle-campaign-settings-switch.form-control-static[data-bind]': {
        display: 'inline-block',
        textDecoration: 'none',
        paddingRight: '8px',
        float: 'left',
      },
      ...toggleButtonStyle(core),
      '& .date-settings-intro': {
        paddingLeft: 0,
      },
      '& .date-settings': {
        '& .col-sm-12': {
          paddingLeft: 0,
        },
        '& table': {
          width: '500px',
          '& td': {
            width: '100%',
            display: 'block',
          },
        },
      },
      '& .alert-danger': {
        backgroundColor: 'unset',
        color: '#A80000',
      },
    },
  });

// reference: private/campaign-legacy/packages/campaign-targeting/view/campaign-targeting.js
export const AdSchedule = React.memo((props) => {
  const {
    setAdScheduleView,
    getAdScheduleView,
    options,
    getCreatedView,
    managed,
  } = props;
  const adScheduleReactWrapper = useBackboneView(useCallback(() => new AdScheduleView({
    ...options,
  }).render(), [options]), setAdScheduleView, { managed, getCreatedView });
  const classes = useDefaultStyles(getStyles);

  return (
    <div
      className={classnames(classes.adScheduleContainer)}
      onFocus={() => {
        const view = getAdScheduleView();
        if (view && view.koModel && !_.isEmpty((view.koModel.errors()))) {
          // defer to trigger click event.
          _.delay(view.clearApiErrors.bind(view), 200);
        }
      }}
    >
      <div className="adschedule-targets-container">
        {adScheduleReactWrapper}
      </div>
    </div>
  );
});

AdSchedule.propTypes = {
  setAdScheduleView: PropTypes.func.isRequired,
  getAdScheduleView: PropTypes.func.isRequired,
  getCreatedView: PropTypes.func,
  options: PropTypes.shape({}),
  managed: PropTypes.bool,
};

AdSchedule.defaultProps = {
  options: {
    level: 'campaign',
    model: {
    },
  },
  managed: false,
  getCreatedView: null,
};
